import logo from "./logo.svg";
import "./App.css";
import AddGames from "./screens/AddGames";
import MainPage from "./screens/MainPage";
import { Routes, Route } from "react-router-dom";
import LoginPage from "./screens/LoginPage";
import { AuthProvider } from "./hook/useAuth";
import { ProtectedRoute } from "./routes/ProtectedRoute";
import { HelmetProvider } from "react-helmet-async";
import Clarity from '@microsoft/clarity';


function App() {
  const helmetContext = {};
  Clarity.init("vxooq80nwp");
  return (
    <HelmetProvider context={helmetContext}>
      <AuthProvider>
        <div className="w-full max-w-md md:max-w-lg mx-auto relative min-h-screen bg-semi-blue">
          <Routes>
            <Route path="/" element={<MainPage />} />
            <Route path="/apps" element={<MainPage />} />
            <Route path="/game/:slug" element={<MainPage />} />
            <Route path="/app/:slug" element={<MainPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AddGames />
                </ProtectedRoute>
              }
            />
          </Routes>
        </div>
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;
